/* Amorem — email capture popup. Vanilla, no deps.
   Triggers (delay + desktop exit-intent), frequency cap (localStorage),
   submits to Klaviyo client subscribe API. Config via data-* attrs. */
(function () {
  var root = document.getElementById('AmoremCapture');
  if (!root) return;

  var KEY_UNTIL = 'amorem_cap_until';   // don't show again before this timestamp
  var KEY_DONE = 'amorem_cap_done';     // subscribed — never show again

  var cid = root.getAttribute('data-cid');
  var listId = root.getAttribute('data-list');
  var delay = parseInt(root.getAttribute('data-delay'), 10);
  if (isNaN(delay)) delay = 8;
  var exitIntent = root.getAttribute('data-exit-intent') === 'true';
  var freqDays = parseInt(root.getAttribute('data-freq-days'), 10);
  if (isNaN(freqDays)) freqDays = 14;
  var allowMobile = root.getAttribute('data-mobile') === 'true';
  var source = root.getAttribute('data-source') || 'Amorem site popup';

  if (!cid || !listId) return;

  // Quiz visitors already gave their email in the quiz — never show them an email popup
  // (asking again kills conversion on paid quiz traffic). Signals: ?symbol= or tos_aid in
  // the URL, or a persisted tos_aid (posthog.liquid writes it to localStorage on arrival).
  function isQuizVisitor() {
    try {
      var qp = new URLSearchParams(location.search);
      if (qp.get('symbol') || qp.get('tos_aid')) return true;
    } catch (e) {}
    try { if (localStorage.getItem('tos_aid')) return true; } catch (e) {}
    return false;
  }
  if (isQuizVisitor()) return;

  // Never interrupt buying intent: no popup on the cart page (it was firing 20s into
  // cart review and sitting between the shopper and the Checkout button).
  if (/(^|\/)cart(\/|$)/.test(location.pathname)) return;

  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  if (isMobile && !allowMobile) return;

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  if (read(KEY_DONE) === '1') return;
  var until = parseInt(read(KEY_UNTIL), 10);
  if (until && Date.now() < until) return;

  var overlay = root.querySelector('[data-amcap-overlay]');
  var form = root.querySelector('[data-amcap-form]');
  var emailEl = root.querySelector('[data-amcap-email]');
  var submitBtn = root.querySelector('[data-amcap-submit]');
  var errorEl = root.querySelector('[data-amcap-error]');
  var formView = root.querySelector('[data-amcap-form-view]');
  var successView = root.querySelector('[data-amcap-success-view]');
  var closeEls = root.querySelectorAll('[data-amcap-close]');
  var opened = false, armed = true;

  function open() {
    if (opened || !armed) return;
    opened = true; armed = false;
    disarm();
    root.hidden = false;
    // Forced reflow instead of requestAnimationFrame: rAF is suspended in background
    // tabs, which used to leave the layer un-hidden but without .is-open - an invisible
    // full-screen state. Reflow keeps the CSS transition and applies the class right away.
    void root.offsetWidth;
    root.classList.add('is-open');
    if (emailEl) setTimeout(function () { try { emailEl.focus(); } catch (e) {} }, 80);
    document.addEventListener('keydown', onKey);
  }

  function snooze() {
    store(KEY_UNTIL, String(Date.now() + freqDays * 86400000));
  }

  function close(skipSnooze) {
    if (!skipSnooze) snooze();
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { root.hidden = true; }, 260);
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  function disarm() {
    if (timer) clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
  }

  function onExit(e) {
    if (e.clientY <= 0 && (!e.relatedTarget && !e.toElement)) open();
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  function submit(e) {
    e.preventDefault();
    var email = (emailEl.value || '').trim();
    errorEl.hidden = true;
    if (!validEmail(email)) { errorEl.hidden = false; emailEl.focus(); return; }
    submitBtn.disabled = true;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cid), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (res.ok || res.status === 202) {
        store(KEY_DONE, '1');
        try { if (window.posthog) posthog.capture('email_subscribe', { source: 'storefront_popup' }); } catch (e) {}
        if (formView) formView.hidden = true;
        if (successView) successView.hidden = false;
      } else {
        submitBtn.disabled = false;
        errorEl.hidden = false;
      }
    }).catch(function () {
      submitBtn.disabled = false;
      errorEl.hidden = false;
    });
  }

  if (form) form.addEventListener('submit', submit);
  if (overlay) overlay.addEventListener('click', function () { close(); });
  // Fallback: a tap anywhere outside the card (on the flex container itself) also closes.
  root.addEventListener('click', function (e) { if (e.target === root) close(); });
  Array.prototype.forEach.call(closeEls, function (el) {
    el.addEventListener('click', function () { close(); });
  });

  var timer = setTimeout(open, delay * 1000);
  if (exitIntent && !isMobile) document.addEventListener('mouseout', onExit);
})();
